<template>
    <div>
        <ui-select
            v-model="data.type"
            :options="types"
            label="Type"
            name="type"
        />

        <div v-if="allowedFields.length">
            <div
                v-if="allowedFields.includes('image')"
                class="
                    d-flex
                    flex-column
                    flex-md-row
                    align-items-md-center
                    justify-content-md-between
                    mb-4
                "
            >
                <ui-avatar
                    size="medium"
                    :src="imageUrl"
                ></ui-avatar>

                <ui-input-file
                    name="image"
                    class="mt-3 mt-md-0 ml-md-4"
                    optional
                ></ui-input-file>

                <ui-input-checkbox
                    v-if="imageUrl !== ''"
                    name="unlink_image"
                    id="unlink_image"
                    label="Verwijder afbeelding"
                ></ui-input-checkbox>
            </div>

            <ui-editor
                v-if="allowedFields.includes('text_without_question')"
                class="mb-4"
                name="options[text-without-question]"
                :value="textWithoutQuestion"
            ></ui-editor>

            <ui-input
                v-if="allowedFields.includes('true_false')"
                name="options[true-false][true]"
                type="text"
                label="Ja"
                :value="trueFalse ? trueFalse.true : null"
            />

            <ui-input
                v-if="allowedFields.includes('true_false')"
                name="options[true-false][false]"
                type="text"
                label="Nee"
                :value="trueFalse ? trueFalse.false : null"
            />

            <ui-dynamic-form
                v-if="allowedFields.includes('options')"
                :key="`options[${data.type}]`"
                :name="`options[${data.type}]`"
                layout="horizontal"
                colClass="col-lg-6 col-xl-6 col-xl-6 mb-3"
                :rows="options ? options[data.type] : []"
                :fields="[
                {
                    type: 'text',
                    name: 'label',
                    label: 'Label',
                    min: 1,
                    max: 255,
                    required: true,
                },
                {
                    type: 'number',
                    name: 'order',
                    label: 'Order',
                    min: 1,
                    max: 255,
                    step: 1,
                    required: false,
                },
            ]"
            />

            <div
                v-if="allowedFields.includes('options')"
                class="
                    p-4
                    bg-info
                "
            >
                {{ $t('mind.input_options_info') }}
            </div>

            <div
                v-if="allowedFields.includes('file')"
                class="
                    d-flex
                    flex-column
                    flex-md-row
                    align-items-md-center
                    justify-content-md-between
                    mb-4
                "
            >
                <ui-input-file
                    name="file_download"
                    class="mt-3 mt-md-0"
                    optional
                ></ui-input-file>

                <ui-input-checkbox
                    v-if="downloadUrl !== ''"
                    name="unlink_file"
                    id="unlink_file"
                    label="Verwijder bestand"
                ></ui-input-checkbox>

                <div
                    v-if="downloadUrl !== ''"
                >
                    <a
                        :href="downloadUrl"
                        target="_blank"
                    >
                        Download bestand
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import UiAvatar from '../ui/avatar.vue';
import UiInputCheckbox from '../ui/input-checkbox.vue';
import UiEditor from '../ui/editor.vue';
import UiSelect from '../ui/select.vue';
import UiInput from '../ui/input.vue';
import UiInputFile from '../ui/input-file.vue';
import UiDynamicForm from '../ui/dynamic-form/index.vue';

export default {
    name: 'MindAssignmentTask',
    components: {
        UiAvatar,
        UiEditor,
        UiInputCheckbox,
        UiSelect,
        UiInput,
        UiInputFile,
        UiDynamicForm,
    },
    data() {
        return {
            data: {
                type: this.type,
                options: this.options,
            },
        };
    },
    props: {
        type: {
            type: String,
            default: '',
        },
        types: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            default: () => {},
        },
        downloadUrl: {
            type: String,
            default: '',
        },
        imageUrl: {
            type: String,
            default: '',
        },
    },
    computed: {
        textWithoutQuestion: function() {
            if (this.data.options === null || this.data.options === undefined) {
                return;
            }

            if (this.data.options['text-without-question']) {
                return this.data.options['text-without-question'];
            }
        },
        trueFalse: function() {
            if (this.data.options === null || this.data.options === undefined) {
                return;
            }

            if (this.data.options['true-false']) {
                return {
                    true: this.data.options['true-false']['true'],
                    false: this.data.options['true-false']['false'],
                };
            }
        },
        allowedFields() {
            return this.types.find((type) => type.value === this.data.type)?.allowedFields || [];
        },
    },
};
</script>
